import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { Input, Icon } from "@h3/antd-vue";
import { AddressControl } from "../control/address-control";
import { FromAddressValueService } from "@cloudpivot/form/src/common/services";
import { FormLocationControl } from "@cloudpivot/form/src/common/controls/form-location-control";
let Address = class Address extends AddressControl {
    //  pca:any = {}
    get initMap() {
        console.log('ddddd', FormLocationControl);
        return FormLocationControl.service.initMap;
    }
    // subscription?: Subscription;
    //   get value(){
    //     return this.ctrl.value || {};
    //   }
    //   setControl() {
    //     if (this.ctrl.value) {
    //       this.setPcaDate();
    //     }
    //     this.unsubscribe();
    //     this.subscription = (this.ctrl as any).valueChange.subscribe((change:any) => {
    //       if(this.ctrl.value){
    //         this.setPcaDate();
    //       }else{
    //         this.ctrl.value = {};
    //       }
    //     });
    //   }
    valueChange(val) {
        super.valueChange(val);
    }
    mapChange(val) {
        FromAddressValueService.setAddressVal(val.adcode, this.controlOpts.locationType).then((value) => {
            const type = this.controlOpts.locationType.split("-").length;
            if (type === 3) {
                value.address = val.address;
            }
            else if (type === 2) {
                value.address = `${val.districtName}${val.address}`;
            }
            else {
                value.address = `${val.cityName}${val.districtName}${val.address}`;
            }
            // 给地址加上经纬度参数
            value.lng = val.lng;
            value.lat = val.lat;
            this.setValue(value);
        });
    }
    // valueChange(val:any) {
    //   let value:any =  {};
    //   const { detailAd } = this.ctrl.value;
    //   if (detailAd) {
    //     value.address = detailAd;
    //   }
    //   value = Object.assign(value,val);
    //   this.ctrl.value = value;
    //   this.setPcaDate();
    // }
    onAdChange(evt) {
        // debugger
        if (evt.type === "change") {
            return;
        }
        this.ctrl.value = JSON.parse(JSON.stringify(this.ctrl.value));
        this.ctrl.value = Object.assign({}, this.val, {
            address: evt.target.value
        });
    }
};
Address = tslib_1.__decorate([
    Component({
        name: "input-address",
        components: {
            ATextarea: Input.TextArea,
            AIcon: Icon,
            SmartLocation: () => import("@cloudpivot/form/src/common/components/smart-location/index.vue"),
            PcaSelector: () => import("@cloudpivot/form/src/common/components/pca-selector/pca-selector.vue")
        }
    })
], Address);
export default Address;
